/* eslint-disable */
import React from "react";
import { Link, useHistory } from "react-router-dom";

const HeaderWithoutMenu = () => {
  const history = useHistory();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const redirectToPreviousPage = () => {
    if (history.length > 1) {
      history.goBack(); // Go back if there's a previous page
    }
  };

  return (
    <header className="header_outer bg_white details_header">
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container-fluid">
          <div className="bttm_innr d-flex align-items-center w-100">
            <div className="event_details_top d-flex align-items-center justify-content-between w-100">
              <div className="evant_back">
                <Link
                  to="#"
                  onClick={redirectToPreviousPage}
                  className="d-flex align-items-center gap-2  btn body_bg text-primary"
                >
                  <i className="material-icons-outlined fs-lg text-primary">
                    arrow_back
                  </i>
                  <span>Back</span>
                </Link>
              </div>
              <div className="search_register_outer d-flex align-items-center gap-3 justify-content-end">
                {userInfo ? (
                  <div className="hdr_btn dropdown">
                    <Link
                      to="/logout"
                      className="btn primary-btn"
                      data-bs-toggle="dropdown"
                    >
                      <span> My Account</span>
                      <i className="material-icons-outlined">expand_more</i>
                    </Link>
                    <ul className="list_style_none dropdown-menu">
                      <li>
                        <Link to="/myaccount">My Profile</Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/myinvites">My Invites</Link>
                      </li>
                      <li>
                        <Link to="/logout">Log out</Link>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <div className="hdr_btn">
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#login_modal"
                      className="btn primary-btn"
                    >
                      Login
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div className="overlay"></div>
    </header>
  );
};

export default HeaderWithoutMenu;
